import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingService } from '../core/loading/loading.service';
import { UserService } from '../core/user/user.service';
import { takeUntil } from 'rxjs/operators';



@Component({
	selector: 'pgs-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

	private ngUnsubscribe: Subject<void>;

	// roles = [
	// 	{
	// 		id: 'userManteiner',
	// 		name: 'Administrador operacional'
	// 	},
	// 	{
	// 		id: 'userVendorPaymentHeader',
	// 		name: 'Portería'
	// 	},
	// 	{
	// 		id: 'userVendorPaymentDetail',
	// 		name: 'Control proveedor'
	// 	},
	// 	{
	// 		id: 'userLeadership',
	// 		name: 'Jefaturas'
	// 	},
	// 	{
	// 		id: 'userBilling',
	// 		name: 'Facturación'
	// 	},
	// 	{
	// 		id: 'userAccountingAssistant',
	// 		name: 'Asistente Contable'
	// 	},
	// 	{
	// 		id: 'userTransferProvider',
	// 		name: 'Control Proveedor Traspaso'
	// 	}
	// ];

	isAuthenticated = false;
	isAuthenticating = false;

	constructor(
    private userService: UserService,
		private loadingService: LoadingService
  ) { }

	ngOnInit(): void {
		this.ngUnsubscribe = new Subject<void>();
/*		this.securityService.authenticationStatus
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(value => {
      if (value < 2) { this.loadingService.show('Iniciando sesión'); }
    });*/
	}


	ngOnDestroy(): void {
		if (this.ngUnsubscribe) {
			this.ngUnsubscribe.next();
			this.ngUnsubscribe.complete();
		}
	}

	// changeUser(role: any): void {
	// 	if (role.disabled) {
	// 		return;
	// 	}

	// 	this.loadingService.show();
	// 	this.userService.changeRole(role.id).takeUntil(this.ngUnsubscribe)
	// 		.finally(() => this.loadingService.hide())
	// 		.subscribe(
	// 		user => {
	// 			if (user) {
	// 				this.loadingService.hide();
	// 			}
	// 		}
	// 		);
	// }

	// isActive(roleId: string): boolean {
	// 	return this.userService.roleId === roleId;
	// }
}
